export type AuthorType = 1 | 2 | 3
export const getAuthorLabel = (authorType: AuthorType): string => {
  return authorType === 1
    ? '著者'
    : authorType === 2
    ? '編著者'
    : authorType === 3
    ? '編訳者'
    : '著者'
}

// SNS関連
export const FACEBOOK_HASH_TAG = '%23学びメモ'
export const TWITTER_HASH_TAG = encodeURI('学びメモ,フライヤー')
export const FACEBOOK_SHARE_LINK =
  'https://www.facebook.com/share.php?u=https://www.flierinc.com/summary/'
export const TWITTER_SHARE_LINK =
  'https://twitter.com/share?url=https://www.flierinc.com/summary/'

export const twitterTrim = (text: string): string => {
  const text_array = text.split('')
  const len = 230 // 全角115文字以上、半角230文字以上で切って、後ろに「... 」をつける：140文字 * 2byte - 4byte(後ろにつく「... 」) - 23byte(URLは11.5文字換算) - 22byte(ハッシュタグ「#フライヤー #学びメモ」は11文字換算)
  let count = 0
  let str = ''

  for (let i = 0; i < text_array.length; i++) {
    // eslint-disable-next-line no-control-regex
    if (text_array[i].match(/[^\x01-\x7E]/)) {
      count += 2
    } else {
      count++
    }

    if (count >= len) {
      return str + '... '
    }
    str += text.charAt(i)
  }
  return text
}

/**
 * 続きを読むボタンが必要か判定する
 *
 * @param str 文字列
 * @return  boolean true: 必要、false: 不要
 */
export function needReadMore(str: string): boolean {
  const newlineCount = str.split('\n').length
  return newlineCount > 4 || str.length > 130
}
